import { render } from "./CheckText.vue?vue&type=template&id=b907bf18&scoped=true"
import script from "./CheckText.vue?vue&type=script&lang=js"
export * from "./CheckText.vue?vue&type=script&lang=js"

import "./CheckText.vue?vue&type=style&index=0&id=b907bf18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b907bf18"]])

export default __exports__